<!--
  送信履歴一覧モーダルコンポーネント
  このコンポーネントは、メールおよびSMSの送信履歴を表示するために使用されます。
  ユーザーは、過去180日間のメール送信履歴、SMS送信履歴、
  または両方を90日間閲覧することができます。
  各送信履歴には、送信先、件名、受信状態、開封状態、リンククリック状態、
  そして送付日時が含まれます。
-->
<template>
  <BasicModal
    title="送信履歴一覧"
    width="1080px"
    :canCancel="canCancel"
    :isShowModal="isShowModal"
    @cancel="onCancel"
  >
    <b-tabs style="padding: 0px 24px 24px 24px; margin-bottom: 0px">
      <b-tab-item label="メール（180日間閲覧可・一括送信可）">
        <div class="table-container">
          <div class="sended-list-table">
            <table>
              <thead>
                <tr>
                  <th style="text-align: center">
                    <button
                      class="button is-link is-small custom-color no-hover-background button-bulk-send"
                      @click="clickBulkSendEmail"
                    >
                      <span class="mdi mdi-email icon-margin"></span>
                      <span>一括送付</span>
                    </button>
                  </th>
                  <th class="to">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchEmailWords.word1 = !showSearchEmailWords.word1; clearSearchEmailWords()">
                  送信先
                    </button>
                    <div v-show="showSearchEmailWords.word1" class="search-input-container">
                      <input type="text" v-model="searchEmailWords.word1" placeholder="メールは半角で検索可能です" @focus="searchEmailWords.word1 = ''" />
                    </div>
                  </th>
                  <th class="subject">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchEmailWords.word2 = !showSearchEmailWords.word2; clearSearchEmailWords()">
                      件名
                    </button>
                    <div v-show="showSearchEmailWords.word2" class="search-input-container">
                      <input type="text" v-model="searchEmailWords.word2" placeholder="件名と本文を検索します" @focus="searchEmailWords.word2 = ''" />
                    </div>
                  </th>
                  <th class="detail">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchEmailWords.word3 = !showSearchEmailWords.word3; clearSearchEmailWords()">
                      受信
                    </button>
                    <div v-show="showSearchEmailWords.word3" class="search-input-container">
                      <select v-model="searchEmailWords.word3">
                        <option value="">選択して下さい</option>
                        <option value="未">未</option>
                        <option value="〇">〇</option>
                      </select>
                    </div> 
                  </th>
                  <th class="detail">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchEmailWords.word4 = !showSearchEmailWords.word4; clearSearchEmailWords()">
                      開封
                    </button>
                   <div v-show="showSearchEmailWords.word4" class="search-input-container">
                      <select v-model="searchEmailWords.word4">
                        <option value="">選択して下さい</option>
                        <option value="未">未</option>
                        <option value="〇">〇</option>
                      </select>
                    </div> 
                  </th>
                  <th class="detail">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchEmailWords.word5 = !showSearchEmailWords.word5; clearSearchEmailWords()">
                      リンク
                    </button>
                   <div v-show="showSearchEmailWords.word5">
                      <select v-model="searchEmailWords.word5">
                        <option value="">選択して下さい</option>
                        <option value="未">未</option>
                        <option value="〇">〇</option>
                      </select>
                    </div> 
                  </th>
                  <th class="detail">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchEmailWords.word6 = !showSearchEmailWords.word6; clearSearchEmailWords()">
                      送付日時
                    </button>
                    <div v-show="showSearchEmailWords.word6">
                      <input type="text" v-model="searchEmailWords.word6" placeholder="半角数値で入力下さい" @focus="searchEmailWords.word6 = ''" />
                    </div>
                  </th>
                </tr>
              </thead>
              <template v-for="sk in filteredEmailItems">
                <tr :key="sk.created_at">
                  <td style="min-width: 40px; vertical-align: middle">
                    <div
                      style="
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-left: 8px;
                      "
                    >
                      <b-checkbox
                        :value="getCheckBoxValue(sk)"
                        @input="checkbox(sk, $event)"
                      ></b-checkbox>
                    </div>
                  </td>
                  <td>{{ sk.name }}<br />{{ sk.to_email }}</td>
                  <!-- sanitize-htmlを使ってサニタイズしたコンテンツをtitle属性に設定 -->
                  <td v-text="sk.email_subject" :title="sanitizeContent(sk.email_content)"></td>
                  <td>
                    <div class="check"><span v-if="sk.is_received">○</span></div>
                  </td>
                  <td>
                    <div class="check"><span v-if="sk.is_open">○</span></div>
                  </td>
                  <td>
                    <div class="check"><span v-if="sk.is_link">○</span></div>
                  </td>
                  <td>{{ formatTime(sk.created_at) }}</td>
                </tr>
              </template>
            </table>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="SMS（180日間閲覧可）">
        <div class="table-container">
          <div class="sended-list-table">
            <table>
              <thead>
                <tr>
                  <th class="to">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchSmsWords.word1 = !showSearchSmsWords.word1; clearSearchSmsWords()">
                      送信先
                    </button>
                    <div v-show="showSearchSmsWords.word1">
                      <input type="text" v-model="searchSmsWords.word1" placeholder="半角数値で検索可能です" @focus="searchSmsWords.word1 = ''" />
                    </div>
                  </th>
                  <th class="subject">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchSmsWords.word2 = !showSearchSmsWords.word2; clearSearchSmsWords()">
                        本文
                    </button>
                    <div v-show="showSearchSmsWords.word2">
                      <input type="text" v-model="searchSmsWords.word2" placeholder="本文を検索します" @focus="searchSmsWords.word2 = ''" />
                    </div>
                  </th>
                  <th class="detail">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchSmsWords.word3 = !showSearchSmsWords.word3; clearSearchSmsWords()">
                      受信
                    </button>
                    <div v-show="showSearchSmsWords.word3">
                      <select v-model="searchSmsWords.word3">
                        <option value="">選択して下さい</option>
                        <option value="未">未</option>
                        <option value="〇">〇</option>
                      </select>
                    </div> 
                  </th>
                  <th class="detail">
                    <button class="button is-link is-small custom-color no-hover-background" @click="showSearchSmsWords.word4 = !showSearchSmsWords.word4; clearSearchSmsWords()">
                      送付日時
                    </button>
                    <div v-show="showSearchSmsWords.word4">
                      <input type="text" v-model="searchSmsWords.word4" placeholder="半角数値で入力下さい" @focus="searchSmsWords.word4 = ''" />
                    </div>
                  </th>
                  <!-- <th class="detail">詳細</th> -->
                </tr>
              </thead>
              <template v-for="sk in filteredSMSItems">
                <tr :key="sk.created_at">
                  <td>{{ sk.seeker__name }}<br />{{ sk.to_tel }}</td>
                  <td>{{ sk.sms_content }}</td>
                  <!-- フィルター機能追加のために、th、tdに追加。tdには下記v-ifを追加した。v-ifの中身を変えられないか。　2023/1/9 -->
                  <td>
                    <template>
                      <div class="check">
                        <span v-if="sk.is_receive">○</span>
                      </div>
                    </template>
                  </td>
                  <td>{{ formatTime(sk.created_at) }}</td>
                  <!-- <td>
                    <div class="center-item-wrapper">
                      <button
                        class="button is-small"
                        @click="clickDetailButton(message)"
                      >
                        確認
                      </button>
                    </div>
                  </td> -->
                </tr>
              </template>
            </table>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="メール・SMS（90日間閲覧可）">
        <div class="table-container">
          <div class="sended-list-table">
            <table>
              <thead>
                <tr>
                  <th class="to">送信先</th>
                  <th class="subject">件名</th>
                  <th class="detail">受信</th>
                  <th class="detail">開封</th>
                  <th class="detail">リンク</th>
                  <th class="detail">送付日時</th>
                </tr>
              </thead>
              <template v-for="(sk, index) in actionListing">
                <tr :key="sk.id">
                  <td>{{ sk.name }}<br />{{ sk.type }}</td>
                  <td>{{ sk.subject_content }}</td>
                  <td>
                    <div class="check"><span v-if="sk.is_received">○</span></div>
                  </td>
                  <td>
                    <div class="check"><span v-if="sk.is_open">○</span></div>
                  </td>
                  <td>
                    <div class="check"><span v-if="sk.is_link">○</span></div>
                  </td>
                  <td>{{ formatTime(sk.created_at) }}</td>
                </tr>
              </template>
            </table>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </BasicModal>
</template>
<script>
import BasicModal from "@/components/Modals/BasicModal";
import createUUID from "@/functions/createUUID";
import { mapState } from "vuex";
import ActionSet from "@/components/molecules/fields/ActionSet";
import ModalMessageList from "@/components/organisms/modals/ModalMessageList";
import SelectMemberTable from "@/components/molecules/tables/SelectMemberTable";
import WYSIWYGAndPlainTextEditer from "@/components/ui/WYSIWYGAndPlainTextEditer";
import moment from "moment";
import controlLogMixin from "@/mixins/controlLogMixin";
import sanitizeHtml from 'sanitize-html';


export default {
  name: "SendHistory",
  componentName: "SendHistory",
  components: {
    BasicModal,
    SelectMemberTable,
    WYSIWYGAndPlainTextEditer,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    width: {
      type: String,
      default: () => "1080px",
    },
    isShowModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    canCancel: {
      type: Boolean,
    },
    bulkSeekerList: {
      type: Array,
      required: false,
    },
  },
  mixins: [controlLogMixin],
  created() {
    this.$store.dispatch("auth/getMediaCooperationList");
    this.$store.dispatch("auth/getRecruitmentFlow");
    this.$store.dispatch("directtalk/getActionListing").then((data2) => {
    });
    this.$store.dispatch("directtalk/getSmsListing").then((data1) => {
    });
    this.$store.dispatch("directtalk/getEmailListing").then((data) => {
    });
  },
  computed: {
    ...mapState("auth", [
      "user",
      "users",
      "departments",
      "positions",
      "companyColumnSetting",
      "recruitmentFlows",
      "emailTemplates",
      "calendarSettings",
      "calendarSettingsDisplay",
      "manages",
      "select_manages",
      "default_manage",
      "usersStatusAPI",
      "mediaCooperationList",
      "recruitmentFlowActions",
    ]),
    ...mapState("calendar", [
      "isGoogleAuth",
      "isGaroonAuth",
      "isCybozuAuth",
      "isMSOfficeAuth",
    ]),
    ...mapState("directtalk", [
      "seekers",
      "filteredSeekers",
      "filteredSeekersNum",
      "isSeekerLoading",
      "isApplyListNone",
      "downloadCSV",
      "resumeLoading",
      "pdfFile",
      "isOCRReading",
      "ocrData",
      "getSeekerType",
      "isSavingCustomColumn",
      "recordingInterviews",
      "chatLogs",
      "detailManage",
      "emailListing",
      "smsListing",
      "actionListing",
    ]),
    /**
    * recruitmentFlows内のステージをorderプロパティに基づいてソートします。
    * recruitmentFlowsの最初の要素内にあるステージの配列をソートし、
    * ソートされた配列を返します。
    * @return {Array} ソートされたステージの配列を返します。
    */
    sortByStages() {
      return this.recruitmentFlows[0].stages.slice().sort((stageA, stageB) => {
        if (stageA.order < stageB.order) return -1;
        if (stageA.order > stageB.order) return 1;
        return 0;
      });
    },
    selectData() {
      return this.sortByStages;
    },
    filteredEmailItems() {
      return this.emailListing.filter(sk => {
        const emailData = `${sk.name} ${sk.to_email} ${sk.email_subject} ${sk.email_content}`;
        const isWord1Match = this.searchEmailWords.word1 ? emailData.toLowerCase().includes(this.searchEmailWords.word1.toLowerCase()) : true;
        const isWord2Match = this.searchEmailWords.word2 ? sk.email_subject.toLowerCase().includes(this.searchEmailWords.word2.toLowerCase()) || sk.email_content.toLowerCase().includes(this.searchEmailWords.word2.toLowerCase()) : true;
        const isWord3Match = this.searchEmailWords.word3 ? (this.searchEmailWords.word3 === '未' ? !sk.is_received : sk.is_received) : true;
        const isWord4Match = this.searchEmailWords.word4 ? (this.searchEmailWords.word4 === '未' ? !sk.is_open : sk.is_open) : true;
        // word5 (リンククリック) と word6 (送付日時) のフィルタリングロジックを追加
        return isWord1Match && isWord2Match && isWord3Match && isWord4Match; // word5 と word6 の条件もここに追加
      });
    },
    filteredSMSItems() {
      return this.smsListing.filter(sk => {
        const smsData = `${sk.seeker__name} ${sk.to_tel} ${sk.sms_content}`;
        const isWord1Match = this.searchSmsWords.word1 ? smsData.toLowerCase().includes(this.searchSmsWords.word1.toLowerCase()) : true;
        const isWord2Match = this.searchSmsWords.word2 ? sk.sms_content.includes(this.searchSmsWords.word2) : true;
        const isWord3Match = this.searchSmsWords.word3 ? (this.searchSmsWords.word3 === '未' ? !sk.is_receive : sk.is_receive) : true;
        // word4 (送付日時) のフィルタリングロジックを追加
        return isWord1Match && isWord2Match && isWord3Match; // word4 の条件もここに追加
      });
    },
    selectedDateTime() {
      if (typeof this.selectedTime === "string") {
        const hour = Number(this.selectedTime.split(":")[0]);
        const min = Number(this.selectedTime.split(":")[1]);
        const date = new Date(this.selectedDate);
        date.setHours(hour);
        date.setMinutes(min);
        return date;
      }
      return null;
    },
  },
  data() {
    return {
      bulk: false,
      is_string: false,
      calParameter: {},
      active: false,
      action: null,
      sk: null,
      options: {
        theme: "snow",
        placeholder: "内容を入力...",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
          ],
        },
      },
      //　フィルタ―関連
      searchKey: ['', '未', '〇'],
      searchEmailWords: {
        word1: '',
        word2: '',
        word3: '',
        word4: '',
        word5: '',
        word6: '',
      },
      showSearchEmailWords: {
        word1: false,
        word2: false,
        word3: false,
        word4: false,
        word5: false,
        word6: false,
      },
      showSearchSmsWords: {
        word1: false,
        word2: false,
        word3: false,
        word4: false,
      },
      searchSmsWords: {
        word1: '',
        word2: '',
        word3: '',
        word4: '',
      },
      item: ["smsListing"],
      filtered: [],
      idxFilter: false,
      selectAction: null,
      selectedDate: null,
      selectedTelStartDate: null,
      selectedTelEndDate: null,
      selectedTime: null,
      activeTab: 0,
      isSetting: false,
      sortAsc: false,
      sortDesc: false,
      //momentで任意のdateを作成
      date: moment("2020-01-01"),
      filterScout: false,
      isAllCheck: false,
      valList: [
        "email",
        "scout_mail_flg",
      ],
    };
  },
  methods: {
    clearSearchSmsWords() {
      this.searchSmsWord1 = ''
      this.searchSmsWord2 = ''
      this.searchSmsWord3 = ''
      this.searchSmsWord4 = ''
    },
    clearSearchEmailWords() {
      this.searchEmailWord1 = ''
      this.searchEmailWord2 = ''
      this.searchEmailWord3 = ''
      this.searchEmailWord4 = ''
      this.searchEmailWord5 = ''
      this.searchEmailWord6 = ''
    },
    showEmailContent(sk) {
      const sanitizedContent = this.$sanitize(sk.email_content);

      this.$bvToast.toast(sanitizedContent, {
        title: sk.email_subject,
        autoHideDelay: 5000,
        variant: 'primary',
        toaster: 'b-toaster-top-center',
        html: true  // HTMLコンテンツを解釈するように指定
      });
    },
    sanitizeContent(htmlContent) {
      // HTMLコンテンツをサニタイズしてHTMLタグを取り除く
      return sanitizeHtml(htmlContent, {
        // タグを許可しないことで、すべてのHTMLタグを取り除く
        allowedTags: [],
        // 属性も許可しない
        allowedAttributes: {}
      });
    },
    //　下記を６つのmethodsを新たに入れた。2023/1/22
    checkbox(sk, bool) {
      sk.email = sk.to_email;
      sk.id = sk.seeker;
      this.$emit("checkbox", { sk: sk, isCheck: bool });
    },
    getCheckBoxValue(sk) {
      let index = this.$_.findIndex(this.bulkSeekerList, (obj) => {
        return sk.id === obj.id;
      });
      return index >= 0;
    },
    emptyBulkSeekerList() {
      this.isAllCheck = false;
      this.$emit("checkbox-all", { skList: [], isCheck: false });
    },
    onCancel() {
      this.$emit('cancel'); 
    },
    clickBulkSendEmail() {
      this.$emit("canCancel", false);
      this.$emit("sendEmail", { sk: null, bulk: true }, false);
      this.$emit("cancel");  // モーダルを閉じるためのイベントを発火    
    },
    addUserHash(data) {
      this.calParameter.user_hash = [data.user.user_hash];
    },
    isImmediate(date) {
      return (
        moment(date).format("YYYY/MM/DD") ===
        moment(new Date()).format("YYYY/MM/DD")
      );
    },
    setResetModalData() {
      this.selectAction = null;
      this.selectedDate = null;
      this.selectedTime = null;
      this.activeTab = 0;
    },
    setInitDateAndTime() {
      if (this.selectAction && !this.selectedDate) {
        const selectedDate = new Date(
          new Date().setDate(
            new Date().getDate() + this.selectAction.delay_days
          )
        );
        selectedDate.setHours(
          selectedDate.getHours() + this.selectAction.hours_later
        );
        this.selectedDate = selectedDate;
        if (this.selectAction.delay_time) {
          const hour = this.selectAction.delay_time.split(":")[0];
          const min = this.selectAction.delay_time.split(":")[1];
          this.selectedTime = `${hour}:${min}`;
        } else if (
          this.selectAction.hours_later ||
          this.selectAction.hours_later === 0
        ) {
          const date = new Date();
          const time = new Date(
            date.setHours(
              date.getHours() + Number(this.selectAction.hours_later)
            )
          );
          const hour =
            String(time.getHours()).length === 1
              ? "0" + time.getHours()
              : time.getHours();
          const min =
            String(time.getMinutes()).length === 1
              ? "0" + time.getMinutes()
              : time.getMinutes();
          this.selectedTime = `${hour}:${min}`;
        }
      }
    },
    dateFormat(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    dateTimeFormat(date) {
      return moment(date).format("YYYY/MM/DD HH:mm");
    },
    toggle() {
      this.active = true;
    },
    createRecruitmentFlowActionHistory() {
      this.sendControlLog(
        "応募者アクション設定",
        "次回アクション設定モーダルにて、「登録する」ボタンをクリックした。"
      );
      let createAction = {
        seeker: this.sk.id,
        action: this.selectAction.pk,
        email_content: this.selectAction.email_content,
        ended_at: this.selectedDateTime,
        is_finished: false,
        finished_status: 0,
        calendarId: null,
        target_calendar_user_hash: null,
      };
      this.$store
        .dispatch("directtalk/createRecruitmentFlowActionHistory", createAction)
        .then(() => {
          this.active = false;
        });
    },
    createRecruitmentFlowTelActionHistory() {
      if (this.selectedTelStartDate - this.selectedTelEndDate === 0) {
        alert("開始日時と終了日時を1分以上空けて設定してください。");
        return;
      }
      if (this.selectedTelStartDate > this.selectedTelEndDate) {
        alert("開始日時は終了日時より前に設定してください。");
        return;
      }
      let createAction = {
        seeker: this.sk.id,
        action: this.selectAction.pk,
        email_content: this.selectAction.email_content,
        ended_at: null,
        selectedTelStartDate: this.selectedTelStartDate,
        selectedTelEndDate: this.selectedTelEndDate,
        is_finished: false,
        finished_status: 0,
        target_calendar_user_hash: this.calParameter.user_hash[0],
      };
      let calendarType = null;
      for (const u of this.users) {
        if (u.user_hash == this.calParameter.user_hash[0]) {
          if (u.is_google_calendar_auth) {
            calendarType = "google";
          } else if (u.is_garoon_auth) {
            calendarType = "garoon";
          } else if (u.is_cybozu_office_auth) {
            calendarType = "cybozu";
          } else if (u.is_msoffice_auth) {
            calendarType = "msoffice";
          } else if (u.is_gsession_auth) {
            calendarType = "gsession";
          } else if (u.is_lineworks_auth) {
            calendarType = "lineworks";
          } else if (u.is_nolinkage_auth) {
            calendarType = "nolinkage";
          } else {
            alert(
              "電話のアクションを設定する場合はカレンダー連携を行ってください。"
            );
            return;
          }
        }
      }
      this.sendControlLog(
        "応募者アクション設定",
        "次回アクション設定モーダルにて、「登録する」ボタンをクリックした。"
      );
      let tempInfo = {
        attendees: [this.calParameter.user_hash[0]],
        calendarType: calendarType,
        title: this.sk.name + "様に電話",
        description: this.sk.tel
          ? "以下応募者情報となります\n名前:" +
            this.sk.name +
            "\n電話番号:" +
            this.sk.tel
          : "以下応募者情報となります\n名前:" +
            this.sk.name +
            "\n電話番号:未登録",
        start: this.selectedTelStartDate,
        end: this.selectedTelEndDate,
        user_hash: this.calParameter.user_hash[0],
      };
      if ((calendarType === "gsession")) {
        tempInfo.description = this.sk.tel
          ? "以下応募者情報となります　　　名前:" +
            this.sk.name +
            "　　　電話番号:" +
            this.sk.tel
          : "以下応募者情報となります　　　名前:" +
            this.sk.name +
            "　　　電話番号:未登録";
      }
      this.$store
        .dispatch("calendar/createSchedules", tempInfo)
        .then((data) => {
          this.active = false;
          createAction.calendarId = data.id;
          this.$store.dispatch(
            "directtalk/createRecruitmentFlowActionHistory",
            createAction
          );
        });
    },

    updateRecruitmentFlowActionHistory() {
      this.sendControlLog(
        "応募者アクション変更",
        "次回アクション設定モーダルにて、「変更する」ボタンをクリックした。"
      );
      const data = {
        pk: this.sk.recruitment_flow_action_history[
          this.sk.recruitment_flow_action_history.length - 1
        ].id,
        action: this.selectAction.pk,
        email_content: this.selectAction.email_content,
        ended_at: this.selectedDateTime,
      };
      this.$store
        .dispatch("directtalk/updateRecruitmentFlowActionHistory", data)
        .then(() => {
          this.active = false;
        });
    },
    deleteRecruitmentFlowActionHistory(isTelAction) {
      this.sendControlLog(
        "応募者アクション取り消し",
        "次回アクション設定モーダルにて、「予定の取り消し」ボタンをクリックした。"
      );
      const pk =
        this.sk.recruitment_flow_action_history[
          this.sk.recruitment_flow_action_history.length - 1
        ].id;
      if (!isTelAction) {
        this.$store.dispatch(
          "directtalk/deleteRecruitmentFlowActionHistory",
          pk
        );
        this.$emit("delete-recruit-flow-action", pk);
        this.active = false;
      } else {
        const targetCalendarUserHash =
          this.sk.recruitment_flow_action_history[
            this.sk.recruitment_flow_action_history.length - 1
          ].target_calendar_user_hash;
        let calendarType = null;
        for (const u of this.users) {
          if (u.user_hash == targetCalendarUserHash) {
            if (u.is_google_calendar_auth) {
              calendarType = "google";
            } else if (u.is_garoon_auth) {
              calendarType = "garoon";
            } else if (u.is_cybozu_office_auth) {
              calendarType = "cybozu";
            } else if (u.is_msoffice_auth) {
              calendarType = "msoffice";
            } else if (u.is_gsession_auth) {
              calendarType = "gsession";
            } else if (u.is_lineworks_auth) {
              calendarType = "lineworks";
            } else if (u.is_nolinkage_auth) {
              calendarType = "nolinkage";
            }
          }
        }
        const info = {
          calendarId:
            this.sk.recruitment_flow_action_history[
              this.sk.recruitment_flow_action_history.length - 1
            ].calendarId,
          calendarType: calendarType,
          type: "delete",
          isViaApplicantTable: true,
          user_hash: targetCalendarUserHash,
        };
        this.$store.dispatch("calendar/updateSchedules", info).then(() => {
          this.$store.dispatch(
            "directtalk/deleteRecruitmentFlowActionHistory",
            pk
          );
          this.$emit("delete-recruit-flow-action", pk);
          this.active = false;
        });
      }
    },
    makeContent(action) {
      let content = "";
      if (action.type === 0) {
        content = action.email_content;
      } else if (action.type === 1 && this.$refs.contentEditer) {
        content = this.$refs.contentEditer.plainText;
      }

      // ここ使うのか検討（ここから）
      let botUri = process.env.OWN_ENDPOINT + "/single/仮のURLです";
      let storyUri = process.env.OWN_ENDPOINT + "/recruits/story/仮のURLです";
      let receivedUri =
        process.env.OWN_ENDPOINT + "/message_login/" + this.sk.id;
      // ここ使うのか検討（ここまで）
      return content
        .replace(/__name__/g, this.sk.name)
        .replace(/__bot__/g, botUri)
        .replace(/__robo_url__/g, botUri)
        .replace(/__story__/g, storyUri)
        .replace(/__received_form__/g, receivedUri);
    },
    latestIsFinished(histories) {
      if (typeof histories === "object") {
        if (histories[histories.length - 1]) {
          return histories[histories.length - 1].is_finished;
        }
      }
      return "";
    },
    // 最新の履歴情報を設定
    setLatestInfo(histories) {
      // historiesが配列であり、要素があることを確認
      if (Array.isArray(histories) && histories.length > 0) {
        // 最新の履歴を取得（created_atで降順ソートして最初の要素を取得）
        const latestHistory = histories.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)))[0];

        if (!latestHistory.is_finished) {
          // actionsから最新の履歴に一致するアクションを検索
          const matchingAction = this.actions.find(act => act.pk === latestHistory.action);
          if (matchingAction) {
            this.selectAction = matchingAction.action_data;
            // moment.jsを使用して日時を処理
            const selectedMoment = moment(latestHistory.ended_at);
            this.selectedDate = selectedMoment.toDate();
            this.selectedTime = selectedMoment.format("HH:mm");
            this.isSetting = true;
          } else {
            this.isSetting = false;
          }
        } else {
          this.isSetting = false;
        }
      } else {
        this.isSetting = false;
      }
    },
    formatTime(createdAt) {
      return this.$moment(createdAt).format("YYYY/MM/DD H:mm:ss");
    },
    pageUpdate2() {
      const getSeekerConditions = {
        is_archive: this.archiveSwitch,
        filter_type: this.orSwitch,
        filter: this.filtered,
        page: Number(this.seekersPages),
        perPage: Number(this.perPage),
        manageid: this.currentManage,
      };
      const authUser = this.users.filter((i) => i.email === this.user.email);
      this.$store.dispatch("directtalk/getSubscribedSeekers", {
        conditions: getSeekerConditions,
        authUser: authUser,
        isAgent: this.user.isAgent,
      });
    },

    pageUpdate() {
      this.$store.dispatch('directtalk/getEmailListing')
    },
    addFilter() {
     let toDateTime = new Date(this.toDate); // クローンを作成

     if (toDateTime) {
        toDateTime.setHours(23);
        toDateTime.setMinutes(59);
        toDateTime.setSeconds(59);
      }
      this.filtered.push({
        //　下記２つは活かす。
        //        scout: this.filterScout,
        //        order: t.order_type,
        //        fromDate: this.fromDate,
        //        toDate: toDateTime,
        //        fromAge: this.fromAge,
        //        toAge: this.toAge,
        sortAsc: this.sortAsc,
        sortDesc: this.sortDesc
      });
      //      this.filterMedia = 'その他'
      this.filterScout = false;
      //      this.filterWord = null
      //      this.fromDate = null
      //      toDateTime = null
      //      this.toDate = null
      //      this.fromAge = null
      //      this.toAge = null
      this.sortAsc = false
      this.sortDesc = false
      // 下記は、       this.idxFilter = -1だったのを変えた。
      this.idxFilter = false
      //      this.seekersPages = 1
      this.pageUpdate()
    },
    deleteFilter() {
      this.filtered.splice(i, 1);
      //      this.seekersPages = 1
      //      this.pageUpdate()
    },
  },
  watch: {
    active() {
      if (this.active && this.sk) { // this.skが存在する場合のみ処理を実行
        this.setResetModalData();
        this.setLatestInfo(this.sk.recruitment_flow_action_history);
      }
    },
    selectAction() {
      this.setInitDateAndTime();
    },
    isAllCheck() {
      if (this.isAllCheck) {
        this.bulkSeekerList = this.emailListing;
        this.$emit("checkbox-all", {
          skList: this.bulkSeekerList,
          isCheck: true,
        });
      } else {
        this.$emit("checkbox-all", {
          skList: this.bulkSeekerList,
          isCheck: false,
        });
      }
    },
  },
  filters: {
    formatDate(value) {
      if (!value) return ''
      const date = new Date(value)
      // YYYY/MM/DDの形式に変換する
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return `${year}/${month}/${day}`
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-button {
  position: absolute;
  right: 0;
  top: 7px;
  font-size: 14px;
  margin-left: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: 0;
}
.sended-list-table2 {
  font-size: 20px;
  width: 97%;
  display: block;
  height: 10;
  overflow-y: scroll;
}
.sended-list-table table tr:hover {
  border-width: 5.0 px;
  border-style: groove;
  border-color: #808080;
}
.sended-list-table {
  font-size: 12px;
  width: 97%;
  display: block;
  height: 600px;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-items: center;
  &:before {
    content: "";
    position: absolute;
  }
  table {
    border-collapse: collapse;
    width: 100%;
  }
  tr {
    transition: background-color 0.2s ease; // 背景色の変化のみ遷移効果を適用
    border: 1px solid #e0e0e0; // 通常の境界線
    
    &:hover {
      background-color: rgba(179, 0, 94, 0.1); // 背景色変更のみ
      border: 1px solid #B3005E; // 通常と同じ太さで色だけ変更
    }

  }
  thead {
    position: sticky;
    top: 0px;
    background: white;
    border-bottom: 1px solid black;
    border-top: 1px solid black;
    z-index: 2147483647;
  }
  tbody {
    border-bottom: 1px solid black;
  }
  th {
    padding: 6px;
    border: 1px solid #e0e0e0;
    background-color: white;
  }
  td {
    padding: 6px;
    border: 1px solid #e0e0e0;
  }
  border-collapse: collapse;
  .to {
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .subject {
    width: 320px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .detail {
    width: 64px;
  }
  .deliver,
  .open,
  .link {
    width: 56px;
  }
  .created-at {
    width: 144px;
  }
  .check {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .center-item-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.empty-tr {
  height: 36px;
}
td {
  word-wrap: break-word;
}
.table-container {
  overflow-y: scroll;
}
.table-container::-webkit-scrollbar {
  width: 20px;
  height: 0px;
  visibility: visible;
}
.custom-color {
  background-color: #B3005E;
}
.custom-color:hover {
  color: pink; /* マウスオーバー時の文字色 */
}
.no-hover-background:hover {
    background-color: #B3005E;
}
.email-content-popover {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 8px;
  z-index: 10000000;
}
.toast-primary {
  background-color: #0d6efd; /* これはBootstrapのデフォルトのプライマリ色です */
  color: #ffffff; /* テキスト色を白に設定 */
}
.button-bulk-send-email {
  font-size: 0.875rem;
  padding: 0.25rem 0.75rem;
  height: 2em;
}
.icon-margin {
  margin-right: 4px;
}

.search-input-container {
  margin-top: 4px;
  padding: 4px;
}

.custom-search-input {
  width: 100%;
  padding: 6px 8px;
  font-size: 12px;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  background-color: #fff;
  color: #363636;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: #999;
    font-size: 11px;
  }

  &:focus {
    outline: none;
    border-color: #B3005E;
    box-shadow: 0 0 0 1px rgba(179, 0, 94, 0.2);
  }
}

// selectタグのスタイルも統一
select.custom-search-input {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24'%3E%3Cpath fill='%23363636' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  padding-right: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/contents/SendHistory.vue